// extracted by mini-css-extract-plugin
module.exports = {"background":"App_background__3MY2Q"};